export default __webpack_public_path__ + "static/media/gurvan_gal.11faa68a.png";